/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.handleCartRefresh.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      if (window.theme && theme.manuallyLoadImages) theme.manuallyLoadImages(this);
    });

    this.addEventListener('on:cart:after-merge', () => {
      if (window.theme && theme.manuallyLoadImages) theme.manuallyLoadImages(this);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  handleCartRefresh() {
    const cartForm = this.querySelector('cart-form');
    if (cartForm && typeof cartForm.refresh === 'function') cartForm.refresh();
  }

  updateFromCartChange(html) {
    const cartForm = this.querySelector('cart-form');
    if (cartForm && typeof cartForm.refreshFromHtml === 'function') {
      cartForm.refreshFromHtml(html);
    }
  }
}

if (!window.customElements.get('cart-drawer')) {
  window.customElements.define('cart-drawer', CartDrawer);
}
